class ImageZoom {
  constructor(elemId) {
    this.modal = document.querySelector("#" + elemId)
    this.initializedListeners = false
    this.offsetX = 0
    this.offsetY = 0
    this.scaleValue = 1
    this.isDragging = false
    this.startX = 0
    this.startY = 0
    this.currentX = 0 // Store current translate values
    this.currentY = 0
    this.init()
  }
  init() {
    document.querySelectorAll(".product__modal-opener").forEach((opener) => {
      opener.addEventListener("click", () => {
        this.openModal(opener)
      })
      // preload images
      let img = new Image()
      img.src = opener.dataset.src
      // destroy image
      img = null
    })
  }
  setImgSrc(src) {
    this.modalImage.src = src
  }
  openModal(opener) {
    this.modalImage = this.modal.querySelector(".modal-content img")
    this.modal.style.display = "block"
    this.body = document.querySelector("body")
    this.body.style.overflow = "hidden"
    this.zoom = this.modal.querySelector("input.zoom")
    this.previous = opener.parentElement.previousElementSibling
    this.next = opener.parentElement.nextElementSibling
    this.imgContainer = this.modal.querySelector(".image-wrapper")
    if (!this.initializedListeners) this.addListeners()

    this.setImgSrc(opener.dataset.src)
  }
  closeModal() {
    this.resetZoom()
    this.modal.style.display = "none"
    this.body.style.overflow = ""
  }
  openNext() {
    if (!this.next) return
    this.closeModal()
    this.next.querySelector(".product__modal-opener").click()
  }
  openPrevious() {
    if (!this.previous) return
    this.closeModal()
    this.previous.querySelector(".product__modal-opener").click()
  }
  dragImage(event) {
    if (event.type === "touchmove") {
      event.preventDefault() // This might be necessary to prevent default touch behaviors (like scrolling)
      event = event.touches[0]
    }
    if (this.isDragging) {
      this.offsetX = event.clientX - this.startX
      this.offsetY = event.clientY - this.startY

      this.calculateConstraints()
      // Apply the transform with the constrained values
      this.modalImage.style.transform = `scale(${this.scaleValue}) translate(${this.offsetX}px, ${this.offsetY}px)`
    }
  }
  startDrag(event) {
    if (event.type === "touchstart") {
      event = event.touches[0]
    }
    this.isDragging = true
    this.startX = event.clientX - this.currentX // Compensate for any existing translations
    this.startY = event.clientY - this.currentY
    this.modalImage.style.cursor = "grabbing"
  }
  endDrag() {
    this.isDragging = false
    this.modalImage.style.cursor = "grab"
  }
  calculateConstraints() {
    // Calculate constraints based on image and container sizes
    let maxOffsetX =
      (this.modalImage.clientWidth * this.scaleValue - this.imgContainer.clientWidth) /
      2 /
      this.scaleValue
    let maxOffsetY =
      (this.modalImage.clientHeight * this.scaleValue -
        this.imgContainer.clientHeight) /
      2 /
      this.scaleValue

    // Apply constraints
    if (this.offsetX > maxOffsetX) this.offsetX = maxOffsetX
    if (this.offsetX < -maxOffsetX) this.offsetX = -maxOffsetX
    if (this.offsetY > maxOffsetY) this.offsetY = maxOffsetY
    if (this.offsetY < -maxOffsetY) this.offsetY = -maxOffsetY

    // Update current translation values
    this.currentX = this.offsetX
    this.currentY = this.offsetY
  }
  addListeners() {
    this.modal.querySelector(".close").addEventListener("click", () => {
      this.closeModal()
    })
    this.modal
      .querySelector(".image-modal .modal-button.left button")
      .addEventListener("click", this.openPrevious.bind(this))
    this.modal
      .querySelector(".image-modal .modal-button.right button")
      .addEventListener("click", this.openNext.bind(this))
    this.zoom.addEventListener("input", (event) => {
      this.zoomImage(event.target.value)
    })
    this.modalImage.addEventListener("touchstart", this.startDrag.bind(this))
    this.modalImage.addEventListener("mousedown", this.startDrag.bind(this))
    window.addEventListener("mousemove", this.dragImage.bind(this))
    window.addEventListener("touchmove", this.dragImage.bind(this))
    window.addEventListener("mouseup", this.endDrag.bind(this))
    window.addEventListener("touchend", this.endDrag.bind(this))
    // window.addEventListener("touchcancel", this.endDrag.bind(this))
    this.modalImage.addEventListener("dragstart", (event) => {
      event.preventDefault()
    })
    this.initializedListeners = true
  }
  zoomImage(value) {
    this.scaleValue = value
    var percentage = ((value - this.zoom.min) / (this.zoom.max - this.zoom.min)) * 100.0
    var adjustment = percentage > 50 ? -1 : 1
    percentage = percentage + adjustment
    this.zoom.style.background = `linear-gradient(to right, rgb(var(--secondary-color-pink)) 0%, rgb(var(--secondary-color-pink)) ${percentage}%, rgb(var(--primary-color-white)) ${percentage}%, rgb(var(--primary-color-white)) 100%)`
    this.calculateConstraints()
    this.modalImage.style.transform = `scale(${this.scaleValue}) translate(${this.offsetX}px, ${this.offsetY}px)`
  }
  resetZoom() {
    this.zoom.value = 1
    this.zoomImage(1)
  }
}
